var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.8085,
    cy: 34.161,
    r: 33.871,
    fill: "#6CC399"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 37.617,
    y: 23,
    width: 9,
    height: 21.8,
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 0,
      fill: "rgb(255, 255, 255)"
    },
    rx: 3.822,
    ry: 3.822
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 23,
    width: 9,
    height: 21.8,
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 0,
      fill: "rgb(255, 255, 255)"
    },
    rx: 3.822,
    ry: 3.822
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.866c2bf593efe52d140ce04e7e798cd0.svg";
export { ForwardRef as ReactComponent };